export const VALUES_FIELD_NAME = [
    '%',
    'cm',
    'em',
    'ex',
    'in',
    'mm',
    'pc',
    'px',
    'pt',
    'vh',
    'vw',
    'vmin',
] as const;
export type TYPES_FIELD_NAME = typeof VALUES_FIELD_NAME[number];
